import { useNavigate } from 'react-router-dom';
import { PushNotificationSetup } from '../components/PushNotificationSetup';

function SettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3">
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          >
            ← Назад
          </button>
          <h1 className="text-lg font-bold text-gray-900 dark:text-white">Настройки</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        {/* Push Notifications Setup */}
        <PushNotificationSetup />

        {/* Info */}
        <div className="bg-blue-50 dark:bg-blue-900/20 rounded-2xl p-4">
          <p className="text-sm text-blue-900 dark:text-blue-100">
            💡 <strong>Совет:</strong> После включения уведомлений, приложение появится в системных настройках iOS/Android, где вы сможете управлять разрешениями для микрофона и камеры.
          </p>
        </div>

        {/* Safari Microphone Info */}
        <div className="bg-orange-50 dark:bg-orange-900/20 rounded-2xl p-4">
          <h3 className="text-sm font-bold text-orange-900 dark:text-orange-100 mb-2">
            🎤 Голосовой чат в Safari
          </h3>
          <p className="text-sm text-orange-800 dark:text-orange-200 mb-3">
            Для работы голосового чата в Safari необходимо разрешить доступ к микрофону:
          </p>
          <ol className="text-sm text-orange-800 dark:text-orange-200 space-y-2 list-decimal list-inside">
            <li>Откройте <strong>Настройки Safari</strong></li>
            <li>Найдите раздел <strong>"Веб-сайты"</strong> → <strong>"Микрофон"</strong></li>
            <li>Найдите <strong>clublevel.ru</strong> в списке</li>
            <li>Установите <strong>"Разрешить"</strong> для доступа к микрофону</li>
          </ol>
          <p className="text-xs text-orange-700 dark:text-orange-300 mt-3 italic">
            После изменения настроек обновите страницу для применения изменений
          </p>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
export { SettingsPage };
